module.exports = __webpack_public_path__ + "static/media/close-line.99863379.svg";